import { render, staticRenderFns } from "./ReservationAmountByMonth.vue?vue&type=template&id=59b4cb94"
import script from "./ReservationAmountByMonth.vue?vue&type=script&lang=js"
export * from "./ReservationAmountByMonth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports